<div
     snAssistantSurface="languageLocale"
     i18n-surfaceTitle="@@languageLocale.surface"
     surfaceTitle="Language locale" class="language-locale-edit-container">
  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
      <p>Loading language-locale...</p>
    </div>
  } @else {
    <div class="header">
      <h2>{{ isEditMode ? 'Edit Language-Locale' : 'Add Language-Locale' }}</h2>
    </div>

    <div class="form-content">
      <div class="field">
        <label for="language">Language <span class="required">*</span></label>
        <p-select
          [snAssistantId]="F.languageId"
          inputId="language"
          [options]="languageOptions"
          name="language_id"
          [(ngModel)]="editingLanguageLocale.language_id"
          optionLabel="label"
          optionValue="value"
          placeholder="Select language"
          [filter]="true"
          styleClass="w-full"
          [disabled]="isEditMode">
        </p-select>
      </div>

      <div class="field">
        <label for="locale">Locale <span class="required">*</span></label>
        <p-select
          [snAssistantId]="F.localeId"
          inputId="locale"
          [options]="localeOptions"
          name="locale_id"
          [(ngModel)]="editingLanguageLocale.locale_id"
          optionLabel="label"
          optionValue="value"
          placeholder="Select locale"
          [filter]="true"
          styleClass="w-full"
          [disabled]="isEditMode">
        </p-select>
      </div>

      <div class="models-section">
        <h3>Default Model Versions</h3>

        <div class="field">
          <label for="llmModel">LLM Model</label>
          <!-- Платформенные дефолты локали: агент правит настройки конкретного
               агента, а не то, с чем стартуют все новые. -->
            <app-model-selector-button
              snAssistantSkip
            [modelTypes]="['llm']"
            [modelsHierarchy]="modelsHierarchy"
            [selectedVersionId]="editingLanguageLocale.default_llm_version_id"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [allowModelSelect]="true"
            [showVersions]="false"
            [showPropertiesEdit]="true"
            [allowSelectFromTester]="true"
            label="Select LLM Model"
            (modelSelected)="onLlmModelSelected($event)">
          </app-model-selector-button>
          <p class="field-description">Choose the Language Model provider and specific model version for this language locale.</p>
        </div>

        <div class="field">
          <label for="sttModel">STT Model</label>
          <!-- Платформенные дефолты локали: агент правит настройки конкретного
               агента, а не то, с чем стартуют все новые. -->
            <app-model-selector-button
              snAssistantSkip
            [modelTypes]="['stt']"
            [modelsHierarchy]="modelsHierarchy"
            [selectedVersionId]="editingLanguageLocale.default_stt_version_id"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [allowModelSelect]="true"
            [showVersions]="false"
            [showPropertiesEdit]="true"
            [allowSelectFromTester]="true"
            label="Select STT Model"
            (modelSelected)="onSttModelSelected($event)">
          </app-model-selector-button>
          <p class="field-description">Choose the Speech-to-Text provider and specific model version for transcribing user speech.</p>
        </div>

        <div class="field">
          <label for="ttsModel">TTS Model</label>
          <!-- Платформенные дефолты локали: агент правит настройки конкретного
               агента, а не то, с чем стартуют все новые. -->
            <app-model-selector-button
              snAssistantSkip
            [modelTypes]="['tts']"
            [modelsHierarchy]="modelsHierarchy"
            [selectedVersionId]="editingLanguageLocale.default_tts_version_id"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [allowModelSelect]="true"
            [showVersions]="false"
            [showPropertiesEdit]="true"
            [allowSelectFromTester]="true"
            [defaultFirstMessage]="editingLanguageLocale.default_first_message"
            [languageId]="editingLanguageLocale.language_id"
            [localeId]="editingLanguageLocale.locale_id"
            label="Select TTS Model"
            (modelSelected)="onTtsModelSelected($event)">
          </app-model-selector-button>
          <p class="field-description">Choose the Text-to-Speech provider and specific model version for voice output.</p>
        </div>

        <div class="field">
          <label for="vadModel">VAD Model</label>
          <!-- Платформенные дефолты локали: агент правит настройки конкретного
               агента, а не то, с чем стартуют все новые. -->
            <app-model-selector-button
              snAssistantSkip
            [modelTypes]="['vad']"
            [modelsHierarchy]="modelsHierarchy"
            [selectedVersionId]="editingLanguageLocale.default_vad_version_id"
            [includeAll]="modelsIncludeAll"
            (includeAllChange)="onModelsIncludeAllChange($event)"
            [allowModelSelect]="true"
            [showVersions]="false"
            [showPropertiesEdit]="true"
            [allowSelectFromTester]="true"
            label="Select VAD Model"
            (modelSelected)="onVadModelSelected($event)">
          </app-model-selector-button>
          <p class="field-description">Choose the Voice Activity Detection model for detecting when the user starts and stops speaking.</p>
        </div>

      </div>

      <div class="field">
        <div class="switch-field">
          <div class="switch-content">
            <label class="switch-label">Active</label>
            <p class="field-description">Users can select this language locale in the agent editing interface.</p>
          </div>
          <p-toggleSwitch
            [snAssistantId]="F.isActive"
            inputId="isActive"
            name="is_active"
            [(ngModel)]="editingLanguageLocale.is_active">
          </p-toggleSwitch>
        </div>
      </div>

      <div class="field">
        <div class="switch-field">
          <div class="switch-content">
            <label class="switch-label">Default</label>
            <p class="field-description">Only one language locale can be default - selected when creating an agent if the user's language locale is not supported by the platform.</p>
          </div>
          <p-toggleSwitch
            [snAssistantId]="F.isDefault"
            inputId="isDefault"
            name="is_default"
            [(ngModel)]="editingLanguageLocale.is_default">
          </p-toggleSwitch>
        </div>
      </div>

      <div class="field">
        <label for="firstMessage">Default First Message</label>
        <input
          [snAssistantId]="F.defaultFirstMessage"
          pInputText
          id="firstMessage"
          name="default_first_message"
          [(ngModel)]="editingLanguageLocale.default_first_message"
          placeholder="Enter default first message"
          class="w-full" />
      </div>

      <div class="field">
        <label for="defaultAgent">Default Agent</label>
        <p-select
          [snAssistantId]="F.defaultAgentId"
          inputId="defaultAgent"
          [options]="agentOptions"
          name="default_agent_id"
          [(ngModel)]="editingLanguageLocale.default_agent_id"
          optionLabel="label"
          optionValue="value"
          placeholder="Select default agent (optional)"
          [filter]="true"
          [showClear]="true"
          styleClass="w-full">
        </p-select>
        <small class="help-text">Select the default agent that will be created for new users with this language-locale</small>
      </div>

      <div class="options-section">
        <div class="options-header">
          <h3>Options</h3>
          <p-button
            icon="pi pi-plus"
            label="Add Option"
            severity="primary"
            size="small"
            (click)="onAddOption()">
          </p-button>
        </div>

        @if (editingLanguageLocale.options && editingLanguageLocale.options.length > 0) {
          <div class="options-list">
            @for (option of editingLanguageLocale.options; track $index) {
              <div class="option-card">
                <div class="option-content">
                  <div class="option-name">{{ option.name || 'Unnamed Option' }}</div>
                  <div class="option-description">{{ option.description || 'No description' }}</div>
                </div>
                <div class="option-actions">
                  <p-button
                    icon="pi pi-cog"
                    severity="secondary"
                    [text]="true"
                    [rounded]="true"
                    (click)="onEditOption(option, $index)"
                    pTooltip="Edit settings"
                    tooltipPosition="top">
                  </p-button>
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [text]="true"
                    [rounded]="true"
                    (click)="onDeleteOption($index)"
                    pTooltip="Delete option"
                    tooltipPosition="top">
                  </p-button>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="no-options">No options added yet. Click "Add Option" to create one.</p>
        }
      </div>

      <div class="form-footer">
        <p-button
          label="Cancel"
          severity="secondary"
          [text]="true"
          (click)="onCancel()"
          [disabled]="isSaving">
        </p-button>
        <p-button
          label="Save Changes"
          icon="pi pi-save"
          severity="primary"
          (click)="onSave()"
          [disabled]="!isFormValid || isSaving"
          [loading]="isSaving">
        </p-button>
      </div>
    </div>
  }
</div>

<!-- Drawer for Add/Edit Option -->
<p-drawer
  [(visible)]="showOptionDrawer"
  position="right"
  styleClass="language-locale-option-drawer"
  [modal]="true"
  appPreventOverlayCloseOnScroll>
  <ng-template pTemplate="header">
    <h3>{{ isEditingOption ? 'Edit Option' : 'Add Option' }}</h3>
  </ng-template>

  <div
    class="drawer-content"
    snAssistantSurface="languageLocale"
    i18n-surfaceTitle="@@languageLocale.surface"
    surfaceTitle="Language locale">
    <div class="field">
      <label for="optionName">Name <span class="required">*</span></label>
      <input
        [snAssistantId]="F.name"
        pInputText
        id="optionName"
        name="name"
        [(ngModel)]="editingOption.name"
        placeholder="Enter option name"
        class="w-full" />
    </div>

    <div class="field">
      <label for="optionDescription">Description</label>
      <input
        [snAssistantId]="F.description"
        pInputText
        id="optionDescription"
        name="description"
        [(ngModel)]="editingOption.description"
        placeholder="Enter option description"
        class="w-full" />
    </div>

    <div class="field">
      <label for="systemPrompt">System Prompt</label>
      <textarea
        [snAssistantId]="F.systemPrompt"
        pInputTextarea
        id="systemPrompt"
        name="system_prompt"
        [(ngModel)]="editingOption.system_prompt"
        placeholder="Enter system prompt"
        [rows]="10"
        class="w-full">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancel"
        severity="secondary"
        [text]="true"
        (click)="onCancelOption()">
      </p-button>
      <p-button
        label="Save"
        icon="pi pi-save"
        severity="primary"
        (click)="onSaveOption()"
        [disabled]="!editingOption.name || !editingOption.name.trim()">
      </p-button>
    </div>
  </ng-template>
</p-drawer>

<!-- Confirm Dialog -->
<p-confirmDialog></p-confirmDialog>
